import NotificationTemplate from '@/orm/models/Company/NotificationTemplate/NotificationTemplate';
import { computed } from '@vue/composition-api';

export default function useNotificationTemplate() {
  const notificationTemplates = computed(() => {
    return NotificationTemplate.query().withAllRecursive().get();
  });

  async function getNotificationTemplates(companyId) {
    await NotificationTemplate.api().fetch(companyId);
  }

  async function setNotificationTemplate(id, payload) {
    await NotificationTemplate.api().update(id, payload);
  }

  return {
    notificationTemplates,
    getNotificationTemplates,
    setNotificationTemplate,
  };
}
